import { render, staticRenderFns } from "./OrderStateDelete.vue?vue&type=template&id=27ba3974&"
import script from "./OrderStateDelete.vue?vue&type=script&lang=js&"
export * from "./OrderStateDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports